module.exports = __webpack_public_path__ + "static/img/pic3.4908be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic3.png
// module id = wa9+
// module chunks = 1